import {useState} from 'react';
import ContentModal from '../../organisms/ContentModal';
import {useReport} from '../../../contexts/ReportContext';

import moment from 'moment';

import {useAuth} from '../../../contexts/UserContext';
import StatArea, {DefaultStatsLebel} from '../../organisms/StatArea';
import LabelWithInfo from '../../atoms/LabelWithInfo';
import styled from 'styled-components';
import SimpleBar from 'simplebar-react';
import HappyNumberLabel from '../../atoms/HappyNumberLabel';

const ValueStr = styled.div`
  font-size: 50px;
  font-weight: bold;
  line-height: 50px;
  margin-bottom: 27px;
  text-align: center;
`;

const DateLabel = styled.div`
  font-size: 14px;
  font-weight: bold;
  position: absolute;
  left: 21px;
  top: calc(21px + 1em + 5px);
`;

export default function VenueReportOffline() {
  const report = useReport();
  const auth = useAuth();

  const [modalIsOpen, setIsOpen] = useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  if (!report.state.data || !report.state.data.offline_rooms) {
    return (
        <>
          <div
              style={{
                position: 'relative',
              }}
          >
            <StatArea
                labelWithInfo={
                  <LabelWithInfo
                      text={'Active in the last 30 days'}
                      labelclassname={'stats-name-label'}
                  >
                    <div></div>
                  </LabelWithInfo>
                }
                delta={null}
                button={null}
                style={{
                  backgroundColor: 'transparent',
                }}
            >
              <ValueStr>
                <HappyNumberLabel text="0"/>
              </ValueStr>

              <DefaultStatsLebel text={`rooms/floors`}/>
            </StatArea>
          </div>
        </>
    );
  }

  let data = report.state.data.offline_rooms || {};

  let numerator = data.numerator || 0;
  let denominator = data.denominator || 0;
  let beforeM = moment(data.before);
  let beforeDate = beforeM.toDate();

  return (
      <>
        <div
            style={{
              position: 'relative',
            }}
        >
          <StatArea
              labelWithInfo={
                <LabelWithInfo
                    text={'Active in the last 30 days'}
                    labelclassname={'stats-name-label'}
                >
                  <div>
                    You can monitor the active rooms/floors being online/offline
                    in the last 30 days. Tap 'See more' to view the list.
                  </div>
                </LabelWithInfo>
              }
              delta={null}
              button={
                <button className="dark-button stats-action"
                        onClick={openModal}>
                  <span>See more</span>
                </button>
              }
              style={{
                backgroundColor: 'transparent',
              }}
          >
            <ValueStr>
              <HappyNumberLabel
                  text={(denominator - numerator).toLocaleString('en-US')}/>
            </ValueStr>

            <DefaultStatsLebel text={`${(denominator - numerator) != 1
                ? 'rooms/floors'
                : 'room/floor'}`}/>
          </StatArea>


          <ContentModal closeModal={closeModal} isOpen={modalIsOpen}
                        statmodal={1}>
            <div className="fixed-header">
              <h3>Active in the last 30 days</h3>
              <div className="scroll-header">
                <div className="scroll-header-columns">
                  <div className="scroll-header-column">
                    <span>Room/Floor</span>
                  </div>
                  <div
                      className="scroll-header-column last"
                      style={{
                        //marginRight: 50,
                      }}
                  >
                    <div className="dummy-label">
                      {data.items.map((item, i) => {
                        return (
                            <div
                                key={i}
                                style={{
                                  top: i * -1,
                                }}
                            >
                              {item.text}
                            </div>
                        );
                      })}
                    </div>
                    <span>Last online</span>
                  </div>
                </div>
              </div>
            </div>

            <SimpleBar forceVisible="y" autoHide={false}
                       className="scroll-area">
              <div
                  className={`scroll-content ${
                      data.items.length ? 'has-items' : 'no-items'
                  }`}
              >
                <table className="scroll-table">
                  <tbody>
                  {data.items.map((item, i) => {
                    const m = moment(item.value);
                    const dt = m.toDate();
                    return (
                        <tr key={i} className={beforeDate <= dt ? 'on' : 'off'}>
                          <td className="right-border">
                            {item.room.name}
                          </td>
                          <td className="last">
                            <span className="on-off-text">
                            {item.text}
                              </span>

                          </td>
                        </tr>
                    );
                  })}
                  </tbody>
                </table>
              </div>
            </SimpleBar>
          </ContentModal>
        </div>
      </>
  );
}
